export const customSelectStyle = {
    option: (provided, state) => ({
        color: 'black',
        padding: 10,
        cursor: 'pointer'
    })
}
